import {BaseModel} from "@/models/base/BaseModel";

export class MaintenanceCategory extends BaseModel {
  name: string;

  constructor(name?: string, facilityId?: string, id?: string) {
    super();
    this.id = id ?? "";
    this.name = name ?? "";
    this.facilityId = facilityId ?? "";
  }

  clear() {
    this.name = "";
    this.facilityId = "";
  }
}